import { useRoute } from 'vue-router'

export function useAuthRedirection() {
  const route = useRoute()
  const queryParams = route.query
  const redirectUrl = queryParams.redirectUrl || '/'

  return { redirectUrl }
}
